import { useState } from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import LoginToPlay from "./LoginToPlay"

const PaymentGateWay = () => {
  const [login, setLogin] = useState(false)
  const PaymentItems = [
    {
      id: 1,
      gateway_name: "Major Banks",
      gateway_logo: "/images/payment/fgh-banks.webp",
      gateway_status: "",
      gateway_link: "/profile",
    },
    {
      id: 2,
      gateway_name: "Gcash",
      gateway_logo: "/images/payment/gcash.webp",
      gateway_status: "",
      gateway_link: "/profile",
    },
    {
      id: 3,
      gateway_name: "Maya",
      gateway_logo: "/images/payment/maya.webp",
      gateway_status: "",
      gateway_link: "/profile",
    },
    {
      id: 4,
      gateway_name: "QR PH",
      gateway_logo: "/images/payment/qr-ph.webp",
      gateway_status: "",
      gateway_link: "/profile",
    },
    {
      id: 5,
      gateway_name: "Fortune Pay",
      gateway_logo: "/images/payment/fortune-pay.webp",
      gateway_status: "",
      gateway_link: "/profile",
    },
    {
      id: 6,
      gateway_name: "Crypto Currency",
      gateway_logo: "/images/payment/crypto.webp",
      gateway_status: "",
      gateway_link: "/profile",
    },
  ]

  const initialSlideIndex =
    PaymentItems.length > 1 ? PaymentItems.length - 6 : 0

  // Slick slider settings with dynamic initialSlide
  const settings = {
    dots: false,
    infinite: true,
    speed: 20000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 0,
    cssEase: "linear",
    arrows: false,
    pauseOnHover: false,
    initialSlide: initialSlideIndex,
    responsive: [
      {
        breakpoint: 840,
        settings: {
          slidesToShow: 3,
          speed: 1,
          autoplay: false,
          draggable: true,
          swipe: true,
          swipeToSlide: true,
          touchThreshold: 10,
          waitForAnimate: false,
        },
      },
    ],
  }

  const getStatusStyle = (gateway_status) => {
    switch (gateway_status) {
      case "Offline":
        return { backgroundColor: "red" }
      case "New":
        return { backgroundColor: "#8eb000" } // Change this color as needed.
      default:
        return {}
    }
  }

  // Check localStorage to see if the user is logged in
  const handleGatewayClick = (e) => {
    const isLoggedIn = localStorage.getItem("isLoggedIn")
    if (!isLoggedIn || isLoggedIn === "false") {
      e.preventDefault()
      setLogin(true)
    }
  }

  return (
    <>
      {login && <LoginToPlay onClose={() => setLogin(false)} />}

      <div className="fgh-payment-gateway-section">
        <Slider {...settings}>
          {PaymentItems.map((gateway) => (
            <div key={gateway.id}>
              <a
                href={gateway.gateway_link}
                className="fgh-payment-gateway-link"
                onClick={handleGatewayClick}
              >
                <div className="fgh-payment-gateway-items">
                  {gateway.gateway_status && (
                    <span
                      className="fgh-gateway-status-label"
                      style={getStatusStyle(gateway.gateway_status)}
                    >
                      {gateway.gateway_status}
                    </span>
                  )}
                  <img
                    src={gateway.gateway_logo}
                    alt={gateway.gateway_name}
                    className="fgh-payment--gateway-logo"
                  />
                </div>
              </a>
            </div>
          ))}
        </Slider>
      </div>
    </>
  )
}

export default PaymentGateWay
